import React, { useState } from 'react';
import { Alert, Button, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSubscription } from '../context/SubscriptionContext';
import SubscriptionDialog from './SubscriptionDialog';
import { FACEBOOK_MESSENGER_URL } from '../constants/commonConstants';

export default function SubscriptionGate({ game = 'poker', feature, children }) {
    const { t } = useTranslation();
    const { feature: access, data, ready } = useSubscription();
    const [open, setOpen] = useState(false);
    const value = access(game, feature);
    if (ready === false) return null;
    if (!value.show) return null;
    if (value.allowed) return children;
    return <Box className={`subscription-gate subscription-gate-${feature}`}>
        <Typography>{t(feature === 'game' ? `subscription.${game}` : `subscription.features.${feature}`)}</Typography>
        <Alert severity="info">{t(value.locked ? 'subscription.required' : 'subscription.disabled')}</Alert>
        {value.locked && <Button {...(data?.showSubscribe && data?.doExternalSubscribe
            ? { component: 'a', href: FACEBOOK_MESSENGER_URL, target: '_blank', rel: 'noopener noreferrer' }
            : { onClick: () => setOpen(true) })}>{t('subscription.title')}</Button>}
        <SubscriptionDialog open={open} onClose={() => setOpen(false)} />
    </Box>;
}
